import GoogleTagManagerAddToCart from '@reaffiliates/GoogleTagManager/GoogleTagManagerAddToCart';
import { ICartData } from '@features/cart/typescript';
import GoogleAdwordsAddToCart from '@reaffiliates/GoogleAdwords/GoogleAdwordsAddToCart';
import RTBHouseAddToCart from '@reaffiliates/RTBHouse/RTBHouseAddToCart';
import TikTokAddToCart from '@reaffiliates/TikTok/TikTokAddToCart';
const ReaffiliatesAddToCard = (products: ICartData[]) => {
  GoogleTagManagerAddToCart(products);
  GoogleAdwordsAddToCart(products);
  RTBHouseAddToCart(products);
  TikTokAddToCart(products);
};
export default ReaffiliatesAddToCard;